import { makeCustomIcon } from './utils';

export const dimShapedIcon = makeCustomIcon(
  'Shaped',
  32,
  32,
  'm0 17.616h6.517c5.314 0 5.486 5.073 5.486 7.192l-.003 3.288h2.53v3.904h-14.53zm31.997 0h-6.517c-5.314 0-5.486 5.073-5.486 7.192l.003 3.288h-2.53v3.904h14.53zm-31.994-3.232h6.517c5.314 0 5.486-5.073 5.486-7.192l-.003-3.288h2.53v-3.904h-14.53zm31.997 0h-6.517c-5.314 0-5.486-5.073-5.486-7.192l.003-3.288h-2.53v-3.904h14.53z',
);
